import React, { useEffect, useMemo } from 'react';
import { captureException } from 'utils/exception';

import { Codeowners } from 'components/Common/Error/Codeowners';
import { useToastController } from 'components/Common/Toast';

import { useServices } from '../hooks/useServices';
import { useOnlineBookingReducer } from '../state/useOnlineBookingReducer';

import { ScrollableContent } from './ScrollableContent';
import { ServiceCard } from './ServiceCard';

export const ServiceList = () => {
  const { dispatch, actions, state } = useOnlineBookingReducer();
  const { industry, category, orgUuid } = state;
  const { data: response } = useServices({ orgUuid });
  const { showToast } = useToastController();

  const categories = response?.data?.find((fetchedIndustry) => fetchedIndustry.uuid === industry?.uuid)?.categories;
  const services = categories?.find((fetchedCategory) => fetchedCategory.uuid === category?.uuid)?.services;

  const isOldCategorySelected = useMemo(
    () =>
      categories &&
      state.category &&
      !(categories ?? []).find((fetchedCategory) => fetchedCategory.uuid === state.category?.uuid),
    [categories, state.category]
  );

  useEffect(() => {
    if (isOldCategorySelected) {
      dispatch(actions.resetStep());
      const errorMessage = 'Selected category has changed, please pick another one.';

      captureException(new Error(errorMessage), Codeowners.CUSTOMER_INTAKE);
      showToast(errorMessage);
    }
  }, [actions, dispatch, isOldCategorySelected, showToast]);

  return (
    <ScrollableContent>
      {services?.map((service) => (
        <ServiceCard
          key={service.uuid}
          title={service.name}
          price={service.price}
          image={service.image}
          description={service.description}
          onClick={() => {
            dispatch(actions.selectService(service));
            dispatch(actions.nextStep());
          }}
        />
      ))}
    </ScrollableContent>
  );
};
